module.exports = __webpack_public_path__ + "img/farming_55.527e027d.png";